
export const maxims = [
    {
        title: "Serve Athletes*",
        behaviors: ["I act in service of the athlete*.", "I seek to always do better.", "I connect to sport every day."]
    },  
    {
        title: "Win as a Team",
        behaviors: ["I collaborate with others to accelerate our business.", "I build trust across my network.", "I put the team's success ahead of my own."]
    },
    {
        title: "Do the Right Thing",
        behaviors: ["I fearlessly share my thoughts.", "I play fair.", "I act like an owner by making the best decisions.", "I use the power of sport to unite."]
    },
    {
        title: "Be on the Offense Always",
        behaviors: ["I am a self-starter.", "I prioritize what's most important.", "I simplify and go."]
    },
    {
        title: "Create the Future of Sport",
        behaviors: ["I am constantly curious.", "I build on the great ideas of others.", "I bring great ideas of my own."]
    },
];

export const values = [
    {
        title: "Serve Youth",
        behaviors: ["I act in service of the youth (age and mindset).", "I connect to youth culture every day.", "I seek to always do better."]
    },
    {
        title: "Spark Progress",
        behaviors: ["I build on the great ideas of others.", "I am constantly curious.", "I bring great ideas of my own."]
    },
    {
        title: "Dare Greatly",
        behaviors: ["I am a self-starter.", "I prioritize what's most important.", "I simplify and go."]
    },
    {
        title: "Do the Right Thing",
        behaviors: ["I fearlessly share my thoughts.", "I play fair.", "I act like an owner by making the best decisions."]
    },
    {
        title: "Win Together",
        behaviors: ["I build trust across my network.", "I collaborate with others to accelerate our business.", "I put the team's success ahead of my own"]
    }
];


// WEBPACK FOOTER //
// ./src/components/MaximButtonArray/data.js